import axiosInstance from "@/services/https/global";
import axios from "axios";
import CONFIG from "@/config";

const payoutAdminUrl = `${CONFIG.API_BASE_URL}/payout-service/api/v1/admin`;

const request = async (fn) => {
  try {
    const response = await fn();
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) throw error.response?.data || error;
    throw new Error("An unexpected error occurred");
  }
};

// Interception rules
export const fetchInterceptionRules = () =>
  request(() => axiosInstance.get(`${payoutAdminUrl}/interception-rules/rules`));

export const fetchInterceptionRule = (id) =>
  request(() => axiosInstance.get(`${payoutAdminUrl}/interception-rules/rules/${id}`));

export const createInterceptionRule = (data) =>
  request(() => axiosInstance.post(`${payoutAdminUrl}/interception-rules/rules`, data));

export const updateInterceptionRule = ({ id, data }) =>
  request(() => axiosInstance.put(`${payoutAdminUrl}/interception-rules/rules/${id}`, data));

export const toggleInterceptionRule = (id) =>
  request(() => axiosInstance.put(`${payoutAdminUrl}/interception-rules/rules/${id}/toggle`));

export const deactivateInterceptionRule = (id) =>
  request(() => axiosInstance.delete(`${payoutAdminUrl}/interception-rules/rules/${id}`));

// Runtime config
export const fetchRuntimeConfig = () =>
  request(() => axiosInstance.get(`${payoutAdminUrl}/config`));

export const fetchRuntimeConfigKey = (key) =>
  request(() => axiosInstance.get(`${payoutAdminUrl}/config/${key}`));

export const upsertRuntimeConfig = (data) =>
  request(() => axiosInstance.put(`${payoutAdminUrl}/config`, data));